export const SET_IS_LOADING = 'isLoading/SET_IS_LOADING';
export const setIsLoading = value => ({
  type: SET_IS_LOADING,
  payload: {
    value
  }
});